import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { Nav4AppMenuItem } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-apps/src/common/ui/app-menu-item/Nav4AppMenuItem.tsx';
import type { Nav4ForgeMenuItem$key } from '@atlassian/jira-relay/src/__generated__/Nav4ForgeMenuItem.graphql';

type Nav4ForgeMenuItemProps = {
	queryRef: Nav4ForgeMenuItem$key;
};

export function Nav4ForgeMenuItem({ queryRef }: Nav4ForgeMenuItemProps) {
	const data = useFragment<Nav4ForgeMenuItem$key>(
		graphql`
			fragment Nav4ForgeMenuItem on JiraAppNavigationItem {
				...Nav4AppMenuItem
			}
		`,
		queryRef,
	);

	return <Nav4AppMenuItem queryRef={data} />;
}
